
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/react-grid",
      function () {
        return require("private-next-pages/system/react-grid.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/react-grid"])
      });
    }
  